var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.85022 9.01349L11.8814 1.94485C12.022 1.73588 11.9985 1.4764 11.9985 1.28042C11.9985 0.496523 11.3148 0.5 11.1416 0.5L0.858416 0.5C0.711978 0.5 0.00144768 0.496569 0.00144769 1.28042C0.00144769 1.4764 -0.0218649 1.73593 0.118629 1.94485L5.14977 9.01344C5.53977 9.59363 6.00002 9.49338 6.00002 9.49338C6.00002 9.49338 6.46027 9.59368 6.85022 9.01349Z",
    fill: "#EEEEF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownVector);
export default __webpack_public_path__ + "static/media/DownVector.24c4c5b7aee26e911866eb9bba2247b6.svg";
export { ForwardRef as ReactComponent };